import { lazy } from "react"

// project import
import Loadable from "components/Loadable"
import MinimalLayout from "layout/MinimalLayout"
import { Navigate } from "react-router"
import { isAdminRoute } from "helper/helper"
// render - login
const AuthLogin = Loadable(lazy(() => import("pages/authentication/Login")))

const AuthRegister = Loadable(
  lazy(() => import("pages/authentication/Register"))
)
const AuthForgotPassword = Loadable(
  lazy(() => import("pages/authentication/ForgotPassword"))
)

const AuthResetPassword = Loadable(
  lazy(() => import("pages/authentication/ResetPassword"))
)

const ReviewPage = Loadable(lazy(() => import("pages/Review/ReviewPage")))

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: "/",
  element: <MinimalLayout />,
  children: [
    {
      path: "/",
      element: (
        <Navigate to={isAdminRoute() ? "/admin/login" : "/login"} replace />
      ),
      index: true,
    },
    {
      path: "login",
      element: <AuthLogin />,
    },
    {
      path: "admin/login",
      element: <AuthLogin />,
    },
    {
      path: "register",
      element: <AuthRegister />,
    },
    {
      path: "forgot-password",
      element: <AuthForgotPassword />,
    },
    {
      path: "resetpassword/:token",
      element: <AuthResetPassword />,
    },
    {
      path: "review/:ratingid",
      element: <ReviewPage />,
    },

    {
      path: "*",
      element: <Navigate to="/" replace />,
    },
  ],
}

export default LoginRoutes
